<template>
    <div class="online-service" :style="{'right': width + 'px'}" v-on:mouseenter="mouseEnter" v-on:mouseleave="mouseLeave">
        <div class="online_icon">
            <a id="floatShow" style="display:block;cursor:default;" href="javascript:void(0);" target="_self">
                <img :src="onlineAdvisory" />
            </a>
        </div>
        <div id="onlineService">
            <h2>外汇通客服中心</h2>
            <ul>
              <li class="li01" v-on:click="onlineServiceClick"><img :src="chatIcon" />在线客服</li>
            </ul>
            <p>工作日：8：30-22：30<br>
              节假日：9：00-17：00</p>
            <span class="btn"><img :src="callIcon" />400-099-0087</span>
            <div id="code">
              <img :src="qrCode" />
            </div>
         </div>
    </div>
</template>
<script>
import QrCode from '../../common/footer/images/code.png'
import OnlineAdvisory from '../../../static/img/common/advisory.png'
import ChatIcon from '../../../static/img/common/chat.png'
import CallIcon from '../../../static/img/common/call.png'
export default {
    data: function () {
        return {
            qrCode:QrCode,
            width: -145,
            onlineAdvisory: OnlineAdvisory,
            chatIcon:ChatIcon,
            callIcon: CallIcon
        }
    },
    methods: {
        mouseEnter: function() {
            this.width = 0;
        },
        mouseLeave: function(){
            this.width = -154;
        },
        onlineServiceClick: function(){
            let onlineServiceUrl = window.PAGE_DATA.commonData.servicePath || '';
            window.open(onlineServiceUrl);
        }
    }
}
</script>
<style lang="scss" scoped>
    .online-service{
        position: fixed;
        right: -145px;
        top: 30%;
        margin-top: -154px;
        z-index: 99;
        overflow: hidden;
        .online_icon{
            float: left;
            width: 33px;
            height: 117px;
            margin-top: 50px;
            overflow: hidden;
            zoom: 1;
            a{
                width: 33px;
                height: 117px;
                // background: url('../../../static/img/common/advisory.png') no-repeat 0 0;
                img {
                    width: 100%;
                }
            }
        }
        #onlineService {
            float: left;
            width: 145px;
            height: 270px;
            background: #fff;
            color: #666;
            border-radius: 5px;
            font-size: 12px;
            box-shadow: 1px 1px 7px 2px rgba(0,0,0,.16);
            h2 {
                position: relative;
                height: 32px;
                line-height: 32px;
                margin-bottom: 12px;
                text-align: center;
                background: #364983;
                color: #fff;
                font-size: 12px;
                font-weight: normal;
                border-radius: 5px 5px 0 0;
            }
            ul {
                margin: 0 0 14px 20px;
                li {
                    margin-top: 14px;
                    color: #010101;
                    cursor: pointer;
                    img {
                        float: left;
                        display: inline-block;
                        line-height: 0;
                        font-size: 0;
                        background: url('../../../static/img/common/chat.png') no-repeat;
                        width: 18px;
                        height: 15px;
                        margin: 2px 6px 0 0;
                        background-position: -36px -24px;
                    }
                }
            }
            p {
                padding: 10px 0;
                margin: 0 8px;
                line-height: 22px;
                text-align: center;
                border-top: 1px solid #666666;
            }
            .btn {
                display: block;
                width: 124px;
                height: 26px;
                line-height: 26px;
                margin: 0 auto;
                padding: 0 10px;
                background: #e5211d;
                color: #fff;
                border-radius: 5px;
                text-decoration: none;
                text-align: right;
                img{
                    width: 18px;
                    height: 18px;
                    float: left;
                    padding-top: 4px;
                }
            }
            #code {
                width: 83px;
                height: 83px;
                margin: 10px auto;
                img {
                    width: 100%;
                }
            }

        }
    }
</style>



// WEBPACK FOOTER //
// src/components/common/onlineService/onlineService.vue